module.exports = __webpack_public_path__ + "img/img-section.67a9b302.jpg";